var _rect, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 680 100",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 680,
    height: 100,
    fill: "#FFFFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24 0 L 8 0 L 8 80 L 24 80",
    stroke: "#0052CC",
    strokeWidth: 5.5,
    fill: "none",
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 112 0 L 128 0 L 128 80 L 112 80",
    stroke: "#0052CC",
    strokeWidth: 5.5,
    fill: "none",
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 10,
    height: 40,
    rx: 2,
    fill: "#0052CC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 18,
    width: 10,
    height: 54,
    rx: 2,
    fill: "#0052CC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 4,
    width: 10,
    height: 72,
    rx: 2,
    fill: "#0052CC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 22,
    width: 10,
    height: 48,
    rx: 2,
    fill: "#0052CC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 36,
    width: 10,
    height: 24,
    rx: 2,
    fill: "#0052CC"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 178,
    y: 78,
    fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    fontSize: 80,
    letterSpacing: -2
  }, /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 700,
    fill: "#0052CC"
  }, "V2V"), /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 300,
    fill: "#374151"
  }, "Lab"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8a1457dfd0b7338d0c870d8efe390a17.svg";
export { ForwardRef as ReactComponent };